import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { validateCart } from '@open-tender/utils';
import { ReducerType } from './types';
import { refreshRevenueCenter, setAlert, setCart } from './order';
const initialState = {
    menuVars: null,
    previousMenuVars: null,
    revenueCenters: null,
    categories: [],
    soldOut: [],
    cartErrors: null,
    offsetTop: null,
    error: null,
    loading: 'idle'
};
export var MenuActionType;
(function (MenuActionType) {
    MenuActionType["FetchMenu"] = "menu/fetchMenu";
})(MenuActionType || (MenuActionType = {}));
export const fetchMenu = createAsyncThunk(MenuActionType.FetchMenu, (menuVars, { dispatch, getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    const { revenueCenterId, serviceType, requestedAt } = menuVars;
    try {
        if (requestedAt === null) {
            const err = getState().menu.error;
            throw err;
        }
        const menu = yield api.getMenu(revenueCenterId, serviceType, requestedAt);
        const { cart } = getState().order;
        const { menu: categories, sold_out_items: soldOut, revenue_centers: revenueCenters } = menu;
        const { newCart, errors } = validateCart(cart !== null && cart !== void 0 ? cart : [], categories, soldOut, requestedAt);
        if (errors) {
            dispatch(setCartErrors({ newCart, errors }));
            dispatch(setAlert({ type: 'cartErrors' }));
        }
        else {
            dispatch(setCart(newCart));
            dispatch(resetCartErrors());
        }
        return { categories, soldOut, revenueCenters, menuVars };
    }
    catch (err) {
        dispatch(refreshRevenueCenter(Object.assign(Object.assign({}, menuVars), { reset: true })));
        return rejectWithValue(err);
    }
}));
const menuSlice = createSlice({
    name: ReducerType.Menu,
    initialState,
    reducers: {
        resetMenu: () => initialState,
        resetMenuVars: state => {
            state.menuVars = null;
            state.previousMenuVars = null;
        },
        resetCartErrors: state => {
            state.cartErrors = null;
        },
        setCartErrors: (state, action) => {
            state.cartErrors = action.payload;
        },
        resetOffsetTop: state => {
            state.offsetTop = null;
        },
        setOffsetTop: (state, action) => {
            state.offsetTop = action.payload;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchMenu.fulfilled, (state, action) => {
            return Object.assign(Object.assign(Object.assign({}, state), { previousMenuVars: state.menuVars || null, loading: 'idle', error: null }), action.payload);
        })
            .addCase(fetchMenu.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchMenu.rejected, (state, action) => {
            state.loading = 'idle';
            state.error = action.payload;
        });
    }
});
export const { resetMenu, resetCartErrors, resetMenuVars, resetOffsetTop, setCartErrors, setOffsetTop } = menuSlice.actions;
export const selectMenu = (state) => state.menu;
export const selectSoldOut = (state) => state.menu.soldOut;
export const selectMenuOffset = (state) => state.menu.offsetTop;
export const menuReducer = menuSlice.reducer;
